import {isValidColor} from '../components/LabelColorPicker'
import {LABELS} from '../constants/labels'
import {LABEL_NAME_MAX_LENGTH as SHARED_LABEL_NAME_MAX_LENGTH, validateLabelName} from './validate-label-name'

export const LABEL_NAME_MAX_LENGTH = SHARED_LABEL_NAME_MAX_LENGTH
export const LABEL_DESCRIPTION_MAX_LENGTH = 100

export function validateLabelDescription(description: string) {
  return description.trim().length > LABEL_DESCRIPTION_MAX_LENGTH ? LABELS.descriptionTooLong : null
}

export function validateLabelColor(color: string) {
  return color.trim() ? (isValidColor(color) ? null : LABELS.invalidHexColor) : LABELS.colorRequired
}

export function validateLabelForm(name: string, color: string) {
  return {
    nameError: validateLabelName(name),
    colorError: validateLabelColor(color),
  }
}
